<script>
export default {
  name: "productInfo"
};
</script>

<template>
  <div>商品预览</div>
</template>

<style scoped lang="scss"></style>
